import { useEffect } from 'react'

export const useTabRouting = (currentTab: string, pushRoute: (path: string) => void) => {
  useEffect(() => {
    if (currentTab === 'alerts') {
      pushRoute('/alerts')
    } else if (currentTab === 'reports') {
      pushRoute('/reports')
    } else {
      pushRoute('/')
    }
  }, [currentTab, pushRoute])
}
